import React, { useEffect, useState } from 'react';
import AwesomeTour from '../AwesomeTOur/AwesomeTour';
import Banner from '../Banner/Banner';
import Blogs from '../Blogs/Blogs';
import Discount from '../Discount/Discount';
import Peulis from '../Peulis/Peulis';
import Tours from '../Tours/Tours';
import './Home.css';

const Home = () => {
    const [tours, setTours] = useState([]);

    useEffect(() =>{
        fetch('https://secure-plains-53229.herokuapp.com/items')
        .then(res => res.json())
        .then(data => setTours(data))
    },[]);

    return (
        <div id="home">
            <Banner></Banner>
            <h1 className="my-5 text-center tour-title">Popular tours</h1>
            <p className='text-center'>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Nulla, obcaecati.</p>
            <div className="tour-container">
                {
                    tours.map(tour => <Tours
                    key={tour.id}
                    tour={tour}
                    ></Tours>)
                }
            </div>
            <AwesomeTour></AwesomeTour>
            <Discount></Discount>
            <Peulis></Peulis>
            <Blogs></Blogs>
        </div>
    );
};

export default Home;